export default __webpack_public_path__ + "static/media/costa-rica-plant.e0eb3e4d.png";